module.exports = __webpack_public_path__ + "img/RGB-logo-zeedhi-ED-simples.1c8d2a5a.png";